import Modal from "@/components/general/Modal.vue";

export default {
  components: {
    Modal,
  },
  methods: {
    openModal: function () {
      this.$refs.modalRef.open();
      //Možnost restartovat obsah formu při otevření a zavření modalu - staří přidat VeeValidate ref="form"
      if (this.$refs.form) {
        this.$refs.form.reset()
      }
    },
    closeModal: function () {
      this.$refs.modalRef.close();
      if (this.$refs.form) {
        this.$refs.form.reset()
      }
    }
  }
};
